import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Container = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "isVisible",
})<{ isVisible: boolean }>(
  ({ theme }) => ({
    // "& .MuiPaper-root":{
    position: "fixed",
    bottom: "24px",
    left: "calc(50vw - 200px)",
    borderRadius: theme.shape.borderRadius,
    display: "none",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: theme.palette.secondary.dark,
    width: "540px",
    padding: "16px",
    color: theme.palette.primary.contrastText,
    // },
    "& button": {
      borderRadius: theme.shape.borderRadius,
      backgroundColor: theme.palette.error.main,
      color: theme.palette.primary.contrastText,
      padding: "8px 20px",
      textTransform: "none",
    },
  }),
  ({ isVisible }) => ({
    ...(isVisible && { display: "flex" }),
  })
);
